import React, { useEffect } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { LessonHomeworkSubmissionPageState } from './states/LessonHomeworkSubmissionPageState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { LessonHomeworkHeaderContent } from '../../components/organisms/lesson_homeworks/LessonHomeworkHeaderContent';
import { LessonHomeworkSubmissionForm } from '../../components/organisms/lesson_homeworks/LessonHomeworkSubmissionForm';
import { GrayPage } from '../../components/atoms/layout/gray_page/GrayPage';
import { GrayPageHeader } from '../../components/atoms/layout/gray_page/GrayPageHeader';
import { GrayPageBody } from '../../components/atoms/layout/gray_page/GrayPageBody';
import './lessonHomeworkSubmissionPage.module.scss';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';
import { V3Routes } from '../../routes';

type Props = {
  match: {
    params: {
      homeworkId: string;
    };
  };
};

export const LessonHomeworkSubmissionPage = observer(
  ({
    match: {
      params: { homeworkId },
    },
  }: Props) => {
    useNavigation(NavigationSpecs.side());
    const { pageState } = useLocalStore(() => {
      return {
        pageState: new LessonHomeworkSubmissionPageState(),
      };
    });
    useEffect(() => {
      pageState.init(Number(homeworkId));
    }, [homeworkId]);
    const {
      homework: homeworkResource,
      fieldStates,
      submit,
      submitState: { submitting },
    } = pageState;
    if (homeworkResource.loading) {
      return <LoaderRow />;
    }
    if (homeworkResource.isEmpty()) {
      return <NotFoundPage entityType="課題" />;
    }
    const homework = homeworkResource.getOrThrow();
    const breadCrumbItems = [
      { text: homework.course?.title, to: V3Routes.course(homework.course_id) },
      { text: homework.title },
    ];
    return (
      <GrayPage id="lesson-homework-submission-page">
        <GrayPageHeader>
          <BreadCrumb items={breadCrumbItems} hasHome />
          <LessonHomeworkHeaderContent homework={homework} showReviewer={false} />
        </GrayPageHeader>
        <GrayPageBody>
          {homework.submission_notice && (
            <div
              styleName="homework-submission-notice"
              id="homework-submission-notice"
              dangerouslySetInnerHTML={{ __html: homework.submission_notice }}
            />
          )}
          <LessonHomeworkSubmissionForm fields={fieldStates} loading={submitting} onSubmit={submit} />
        </GrayPageBody>
      </GrayPage>
    );
  }
);
